import React from 'react'
import { ReactReduxContext } from 'react-redux'
import { Modal, ModalBody } from 'reactstrap'
import { Circulation, Website } from '~/types'
import { useSettings } from '../SettingsContext'

interface SelectorModalProps {
  isTemplate: boolean
  isOpen: boolean
  sortedCirculations: Circulation[]
  toggle: (value: boolean) => void
  handleOnMssData: (selectedCirculationData: any) => void
}

const CANCEL_SELECTOR = 'cancelSectionSelector'
const INIT_DATA = 'sendSelectorInitData'
const SEND_DATA = 'selectorANSData'

interface IframeCirculationPayload {
  documentId: string | undefined
  primaryWebsiteId: string
  websites: Website[]
  circulations: Circulation[]
  contentTitle: string
  variants: string
  hierarchy: string
}

export const SelectorModal: React.FC<SelectorModalProps> = ({
  isOpen,
  sortedCirculations,
  toggle,
  handleOnMssData,
}) => {
  const settings = useSettings()

  const iframeRef = React.useRef<HTMLIFrameElement>(null)
  const onDataRef = React.useRef(handleOnMssData)

  React.useEffect(() => {
    onDataRef.current = handleOnMssData
  }, [])

  const { store } = React.useContext(ReactReduxContext)
  const { storyData, websites } = store.getState()

  React.useEffect(() => {
    const initSelectorData = () => {
      if (iframeRef.current?.contentWindow) {
        const payload: IframeCirculationPayload = {
          documentId: storyData?.storyId,
          primaryWebsiteId: storyData?.story?.canonical_website ?? '',
          websites: Object.values(websites) as Website[],
          circulations: sortedCirculations,
          contentTitle: 'Circulation Selector v3',
          variants: 'v3',
          hierarchy: settings?.siteServiceHierarchy
            ? settings?.siteServiceHierarchy
            : 'default',
        }
        iframeRef.current.contentWindow.postMessage(
          {
            message: INIT_DATA,
            action: 'circulate',
            data: payload,
          },
          window.location.origin
        )
      }
    }

    const handleMessage = (event) => {
      if (
        !iframeRef.current ||
        !iframeRef.current.contentWindow ||
        iframeRef.current.contentWindow !== event.source
      ) {
        return
      }

      const { message, data } = event.data

      if (message === 'cancelSectionSelector') {
        toggle(false)
        return
      }

      switch (message) {
        case CANCEL_SELECTOR:
          toggle(false)
          break
        case INIT_DATA:
          initSelectorData()
          break
        case SEND_DATA:
          onDataRef.current(data)
          break
      }
    }

    window.addEventListener('message', handleMessage)

    return () => {
      window.removeEventListener('message', handleMessage)
    }
  }, [
    websites,
    storyData.circulations,
    storyData.isPublished,
    sortedCirculations,
    storyData?.storyId,
    storyData?.story?.canonical_website,
    settings.siteServiceHierarchy,
    toggle,
  ])

  return (
    <Modal
      wrapClassName="site-selector-v2--modal"
      size="lg"
      centered
      isOpen={isOpen}
      toggle={() => toggle(true)}
    >
      <ModalBody>
        <iframe
          ref={iframeRef}
          title="Sites & Sections Selector"
          height="100%"
          width="100%"
          // src="/section-selector/v2"
          src="/circulation-selector/?type=iframe"
        />
      </ModalBody>
    </Modal>
  )
}
